import { createContext } from 'react';

const AppContext = createContext({
  config: { isDark: false },
  toggleDark: () => {},
});

export default AppContext;